import { yupResolver } from "@hookform/resolvers/yup";
import { Resolver } from "react-hook-form";
import { object, string } from "yup";
import { UploadImageForm } from "./types";

const schema = object({
  image: string().trim().nullable().required("Image is required"),
}).required();

export const resolver: Resolver<UploadImageForm> = yupResolver(
  schema,
) as Resolver<UploadImageForm>;
